import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=59ea8dc6&"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrders.vue?vue&type=style&index=0&id=59ea8dc6&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ea8dc6')) {
      api.createRecord('59ea8dc6', component.options)
    } else {
      api.reload('59ea8dc6', component.options)
    }
    module.hot.accept("./PurchaseOrders.vue?vue&type=template&id=59ea8dc6&", function () {
      api.rerender('59ea8dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/PurchaseOrders.vue"
export default component.exports